// extracted by mini-css-extract-plugin
export default {"page_container":"styles_page_container__9Nw3k","greetings":"styles_greetings__-NZzU","start_btn":"styles_start_btn__QZYe1"};